
// @ts-ignore
import {translate} from '@elements/translations';
import {defineComponent} from "vue";

export default defineComponent({
    name: 'RegionTeaser',
    props: {
        name: {
            type: String,
            required: true,
        },
        id: {
            type: String,
            required: true,
        },
        isMainRegion: {
            type: Boolean,
            required: true,
        },
        image: {
            type: String,
            required: true,
        },
        text: {
            type: String,
            required: false,
        },
        isSelected: {
            type: Boolean,
            required: true,
        }
    },
    emits: ['onSelect'],
    setup(props, {emit}) {

        const onSelect = (id: String, isMainRegion: Boolean, name: String) => {
            emit('onSelect', {id, isMainRegion, name});
        }


        return {
            translate,
            onSelect
        };
    }
});
